/**
 * Reusable BreadcrumbList JSON-LD builder.
 *
 * Mirrors the on-page <Breadcrumbs /> trail so search engines see the same
 * hierarchy users see. Use this on every standalone (non-template) page.
 */

const SITE_URL = "https://coloradowebimpressions.com";

export type BreadcrumbItem = {
  name: string;
  /** Path beginning with "/" — omit for the current (final) crumb. */
  path?: string;
};

export function buildBreadcrumbJsonLd(items: BreadcrumbItem[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, idx) => ({
      "@type": "ListItem",
      position: idx + 1,
      name: item.name,
      ...(item.path ? { item: `${SITE_URL}${item.path}` } : {}),
    })),
  };
}

/** Stringified BreadcrumbList JSON-LD ready to drop into a route's `head().scripts`. */
export function breadcrumbScriptTag(items: BreadcrumbItem[]) {
  return {
    type: "application/ld+json",
    children: JSON.stringify(buildBreadcrumbJsonLd(items)),
  };
}
